import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../components/Hero'
import Menu from '../components/Menu'
import Block from '../components/Block'
import Patron from '../components/Patron'
import LittleInfo from '../components/LittleInfo'
import RegistrationButton from '../components/RegistrationButton'
import Footer from '../components/Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab, faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { useRouter } from 'next/router'

export default () => {
  const { basePath } = useRouter();
  
  return <div id="main-container">
    <Head>
      <title>PyCon mini Hiroshima 2019</title>
    </Head>
    <header>
      <Menu />
    </header>
    <div role='main'>
      <Hero heroTitle='PyCon mini Hiroshima 2019' />
      <RegistrationButton />
      <div style={{textAlign: 'center', margin: '1em 0'}}>
        <span className='remarkable-button'>終了しました! </span>
        <p>たくさんのご参加ありがとうございました!</p>
        <p><a href="accounting">会計報告</a></p>
      </div>
      <Block>
        <div className='event-info'>
          <h2>
            <span className='date'>2019年<span className='date-number'>10</span>月<span className='date-number'>12</span>日(<span className='date-day-of-week'>土</span>) 10:00より開催</span>
          </h2>
          <p>
            <span className='date-number-s'><a href="https://www.hiroshima-cu.ac.jp/service/category0004/">広島市立大学サテライトキャンパス</a></span> <LittleInfo>(広島市中区大手町)</LittleInfo>

          </p>
          <p>
            テーマ <span className='theme'>“AI だけじゃない? Python を知ろう!”</span>
          </p>
          <LittleInfo>
            <ul>
              <li>主催 PyCon mini Hiroshima 実行委員会</li>
              <li>共催 広島市立大学</li>
              <li>後援 一般社団法人PyCon JP</li>
            </ul>
          </LittleInfo>
        </div>
      </Block>

      <a name="greeting"/>
      <Block>
        <div className='general-info-vivid'>
          <h2>ごあいさつ</h2>
          <p>
            ちかごろ、急に流行り始めたようにみえるオープンソースのプログラミング言語 Python は、
            1991年に登場し、海外では数多くの著名なソフトウェア開発プロジェクトで使われています。
          </p>
          <p>
            日本でも Python を愛する人たちによる地道な努力が続けられてきました。
            現在の Python の流行は、コミュニティの存在なしには語れません。
          </p>
          <p>
            広島でもっと多くの皆様に、そんな Python を知っていただきたいと思います。
          </p>
        </div>
      </Block>

      <a name="keynote"/>
      <Block title='基調講演: 磯 蘭水 (ISO Ransui)'
             subtitle='ゲームとインタプリタ -DSL作成の愉しみ-'
      >
        <figure className='person-picture' >
          <img src={`${basePath}/images/ransui.jpg`} alt='写真: 磯 蘭水 (ISO Ransui)'/>
        </figure>
        <div className='general-info'>
          <h4>
            磯 蘭水 (ISO Ransui)
            <br/>
            Amazon Web Services Japan / Senior Technical Account Manager
          </h4>
          <ul className='social-links'>
            <li className='twitter'><a href='https://twitter.com/ransui'><FontAwesomeIcon icon={faTwitter} /></a></li>
          </ul>
          <p>
            これまで分散AIの研究、E-Commerceプラットフォーム、サーチエンジン、メディアサーバとメタデータ管理システム、ネット広告配信システム等、数多くのシステムをPythonを用いて開発してきました。 また、趣味の分野においてもPythonは第一のプログラミング言語として活用しています。現在はAmazon Web Servicesのエンタープライズサポートのエンジニアとしてお客様の技術的な課題解決のお手伝いをしており、ここでもPythonが活躍しています。
          </p>
        </div>

      </Block>

      <a name="cfp"/>
      <Block title='スケジュール、公開。' >
        <p>
          発表募集を締め切りました。
          たくさんのご応募ありがとうございました。
          <LittleInfo>2019年9月1日</LittleInfo>
        </p>
        <p>
          <Link href='schedule'><a>スケジュールを公開</a></Link>しました。
          <LittleInfo>2019年9月12日</LittleInfo>
        </p>
      </Block>

      <Block title='参加登録'
             subtitle='受付中'>
        <div>
          <Link href='https://pycon-hiroshima.connpass.com/event/139166/'><a>connpass</a></Link>にて参加登録受付中です。
        </div>
      </Block>

      <Block title='企業パトロン'
             backgroundClass='patrons' >
        <div style={{display: 'grid', gap: '32px 10px', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))'}}>
          <Patron name="株式会社ビープラウド" url='https://www.beproud.jp/' imgsrc={`${basePath}/images/patrons/BP_logo_color.png`} imgsrcset={`${basePath}/images/patrons/BP_logo_color.png 1x, ${basePath}/images/patrons/BP_logo_color@2x.png 2x, ${basePath}/images/patrons/BP_logo_color@3x.png 3x, ${basePath}/images/patrons/BP_logo_color@4x.png 4x`} />
          <Patron name="株式会社ガイアックス" url='https://www.gaiax.co.jp' imgsrc={`${basePath}/images/patrons/gaiax.png`} />
          <Patron name="株式会社てすと" url='https://tesuto.jp' imgsrc={`${basePath}/images/patrons/tesuto.svg`} />
          <Patron name='株式会社ドリーム・アーツ' url='https://www.dreamarts.co.jp/' imgsrc={`${basePath}/images/patrons/DreamArtsLogo_RGB.png`} />
        </div>
      </Block>

      <Block title='個人パトロン'
             backgroundClass='patrons' >
        <div style={{display: 'grid', gap: '32px 10px', gridTemplateColumns: 'repeat(auto-fit, minmax(135px, 1fr))'}}>
          <Patron isPersonal name="秦 誠一郎" url='http://hata-o.jp/kian/index?home' imgsrc={`${basePath}/images/patrons/umenova9.png`} />
          <Patron isPersonal name="池田 道弘" imgsrc={`${basePath}/images/patrons/personal-patron-image.png`} />
          <Patron isPersonal name="長谷場 潤也" url='https://twitter.com/7pairs' imgsrc='https://avatars0.githubusercontent.com/u/1284776' />
          <Patron isPersonal name="masahito" url='https://twitter.com/masahito' imgsrc={`${basePath}/images/patrons/masahito-42042.png`} />
          <Patron isPersonal name='shinyorke' url='https://shinyorke.hatenablog.com/' imgsrc='https://www.gravatar.com/avatar/2c0947c6a28e7f771ebd9859ecf54e5c?size=300' />
          <Patron isPersonal name='slintristeza' url='https://twitter.com/slintristeza' imgsrc='https://pbs.twimg.com/profile_images/1173230616214564865/MQ3bokVB_400x400.jpg' />
          <Patron isPersonal name='gnutar' url='https://twitter.com/gnutar' imgsrc='https://pbs.twimg.com/profile_images/1637035220/kaeru180_400x400.jpg' />
          <Patron isPersonal name='rhoboro' url='https://twitter.com/rhoboro' imgsrc='https://www.rhoboro.com/images/profile/rhoboro.jpg' />
          <Patron isPersonal name='yosukeBaya4' url='' imgsrc={`${basePath}/images/patrons/yosukeBaya4.jpg`} />
          <Patron isPersonal name='koedoyoshida' url='https://www.pycon.jp/committee/board.html' imgsrc='https://www.pycon.jp/_images/yoshida.png' />
        </div>
        <div style={{marginTop: '5em'}}>
          <a href='https://pycon-hiroshima.connpass.com/event/139166/'>connpass</a> にて「企業・団体パトロン」「個人パトロン」募集中です。
        </div>
      </Block>

    <Block title='会場周辺情報'
    subtitle=''>
      <a href='https://bit.ly/pycon_mini_hiro'>会場周辺情報のGoogle Maps</a>をお昼ご飯や駐車場などにご活用ください。
    </Block>

    <Block title='すごい広島 with Python'
           subtitle='月末の水曜は Python でミートアップ'>
      毎週水曜日の夜に開催するミートアップ<a href="https://great-h.connpass.com/event/">「すごい広島」</a>で月末は Python の情報交換をしています。
    </Block>

    <Block title='チーム'>
     
      <p>
        👥 <Link href='team'><a>PyCon mini Hiroshima 2019 のチーム</a></Link> 👥
      </p>
      <p>
        今年の<Link href='team'><a>チーム</a></Link>と一緒に運営を行いませんか? まずは様子を見てみたいという方は是非
        <a href="https://pycon-hiroshima.connpass.com/">PyCon mini Hiroshimaのconnpassグループ</a>
        の運営ミーティング (MTG) に「にぎやかし枠」でお申し込みください。
      </p>
    </Block>

      <Block>
         協力 株式会社 総合オリコミ社
      </Block>
      
    <Block title='過去の記録'
      backgroundClass='bg-dark'
    >
      <ul>
        <li><a href='/2018'>2018年の記録</a></li>
        <li><a href='/2016'>2016年の記録</a></li>
        <li><a href='/2015'>2015年の記録</a></li>
      </ul>
    </Block>
    </div>

    <Footer/>
  </div>
}
